import Email from './../images/Group 223.png';
import Phone from './../images/Group 227.png';
import Contact from './../images/Group 242.png';
import Globus from './../images/freepik-export-20240526141625VraB 1.png';
import Samalyotik from './../images/samalyotik.png';

const ContactUsBlock = () => {
  return (
    <div className="w-full mt-[80px] pb-[80px] bg-[#F4EBDC] relative">
      <div className="flex justify-around">
        <img className="w-[200px] lg:w-[350px]" src={Email} alt='png' />
        <img className="w-[170px] lg:w-[400px] self-center md:self-end" src={Contact} alt='png' />
      </div>
      <div className="flex justify-around flex-col lg:flex-row mt-10 items-center">
        <img className="max-w-[375px] lg:max-w-[600px]" src={Phone} alt='png' />
        <img className="max-w-[375px] lg:max-w-[480px]" src={Globus} alt='png' />
      </div>
      <div className="flex justify-center">
        <img className="absolute top-[74%] left-2 lg:left-[34%]" alt="png" src={Samalyotik} />
      </div>
    </div>
  );
};

export default ContactUsBlock;
